import React, { Component } from 'react'
import { I18n } from 'react-i18next'
import request from 'superagent'
import Notification from './Notification'
import './Form.css'

class Form extends Component {
  constructor (props) {
    super(props)

    this.state = {
      success: null
    }
  }

  sendForm (e) {
    const req = request.post(this.props.sendTo)
    const config = this.props.config
    config.data.email = e.target.email.value

    req.set('Content-Type', 'application/json')
    req.set('Accept', 'application/json')
    req.send(JSON.stringify(config))
    req.end((err, res) => {
      if (err) {
        console.error(err)
        console.log(res)
        this.setState({ success: false })
      } else if (JSON.parse(res.text).code === 200) {
        this.setState({ success: true }, () => {
          setTimeout(this.props.close, 3000)
        })
      }
    })

    e.preventDefault()
  }

  render () {
    return (
      <I18n>
        {(t, { i18n }) => [
          <div
            className='configurator-overlay'
            onClick={this.props.close}
            key='editor-overlay'
          />,
          <div className='configurator-form configurator-modal' key='editor-wrapper'>
            <div className='configurator-controls'>
              <button className='configurator-red-button' onClick={this.props.close}>
                <span className='material-icons'>close</span>
              </button>
            </div>
            {this.props.children}
            {
              this.state.success !== null
                ? <Notification
                  type={this.state.success ? 'success' : 'error'}
                  dismiss={() => this.setState({ success: null })}
                >
                  {t('configurator.form.' + (this.state.success ? 'success' : 'error'))}
                </Notification>
                : null
            }
            <form onSubmit={this.sendForm.bind(this)}>
              <input name='email' type='email' required placeholder='e-mail' />
              <button type='submit' className='configurator-red-button'>
                {t('configurator.form.send')}
              </button>
            </form>
          </div>
        ]}
      </I18n>
    )
  }
}

export default Form



// WEBPACK FOOTER //
// ./src/components/Form.js